<template>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                    <div class="row g-4">
                        <div class="col-12">
                            <h5 class="card-title mb-5">Profile Completion Score</h5>
                            <div class="progress animated-progess custom-progress progress-label">
                                <div :class="item.candidate.profile_completion > 50 ? 'bg-primary' : 'bg-danger'"
                                class="progress-bar" role="progressbar" :style="`width: ${item.candidate.profile_completion}%`"
                                :aria-valuenow="item.candidate.profile_completion"
                                    aria-valuemin="0" aria-valuemax="100">
                                    <div class="label">{{item.candidate.profile_completion}}%</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <h5 class="card-title mb-3">Personal Information</h5>
                    <div class="row g-3 mb-2">
                        <div class="col-sm-3"><span class="text-muted">Full name:</span></div>
                        <div class="col-sm-7"><span>{{ item.last_name }}, {{ item.first_name }} {{ item.middle_name }}</span></div>
                    </div>
                    <div class="row g-3 mb-2">
                        <div class="col-sm-3"><span class="text-muted">Mobile:</span></div>
                        <div class="col-sm-7"><span>{{ item.mobile }}</span></div>
                    </div>
                    <div class="row g-3 mb-2">
                        <div class="col-sm-3"><span class="text-muted">E-mail:</span></div>
                        <div class="col-sm-7"><span>{{ item.email }}</span></div>
                    </div>
                    <div class="row g-3 mb-2">
                        <div class="col-sm-3"><span class="text-muted">Date of birth:</span></div>
                        <div class="col-sm-7"><span>{{ $filters.date(item.dob) }}</span></div>
                    </div>
                    <div class="row g-3 mb-2">
                        <div class="col-sm-3"><span class="text-muted">Gender:</span></div>
                        <div class="col-sm-7 text-capitalize"><span>{{ item.gender }}</span></div>
                    </div>
                    <div class="row g-3 mb-2">
                        <div class="col-sm-3"><span class="text-muted">Marital Status:</span></div>
                        <div class="col-sm-7 text-capitalize"><span>{{ item.marital_status }}</span></div>
                    </div>
                    <div v-if="item.age" class="row g-3 mb-2">
                        <div class="col-sm-3"><span class="text-muted">Age:</span></div>
                        <div class="col-sm-7"><span>{{ item.age }} years</span></div>
                    </div>
                    <div class="row g-3">
                        <div class="col-sm-3"><span class="text-muted">Joined Date:</span></div>
                        <div class="col-sm-7"><span>{{$filters.date(item.created_at) }}</span></div>
                    </div>
                </div>
            </div>
            <div v-if="item.bank_account" class="card">
                <div class="card-body">
                    <h5 class="card-title mb-4">Bank Account</h5>
                    <div class="row g-3 mb-2">
                        <div class="col-sm-3"><span class="text-muted">Account name:</span></div>
                        <div class="col-sm-7"><span>{{item.bank_account.account_name}}</span></div>
                    </div>
                    <div class="row g-3 mb-2">
                        <div class="col-sm-3"><span class="text-muted">Account Number:</span></div>
                        <div class="col-sm-7"><span>{{item.bank_account.account_number}}</span></div>
                    </div>
                    <div class="row g-3">
                        <div class="col-sm-3"><span class="text-muted">Bank:</span></div>
                        <div class="col-sm-7"><span v-if="item.bank_account.bank">{{item.bank_account.bank.name}}</span></div>
                    </div>
                </div>
            </div>
            <div v-if="item.candidate && item.candidate.is_disabled" class="card">
                <div class="card-body">
                    <h5 class="card-title mb-4">Disability</h5>
                    <div class="row g-3 mb-2">
                        <div class="col-sm-3"><span class="text-muted">Disability types:</span></div>
                        <div v-if="item.candidate.disabilities" class="col-sm-7"> {{ item.candidate.disabilities.map(i => i.title).join(', ') }}</div>
                    </div>
                    <div class="row g-3 mb-2">
                        <div class="col-sm-3"><span class="text-muted">Disability supports:</span></div>
                        <div v-if="item.candidate.disability_supports" class="col-sm-7"> {{ item.candidate.disability_supports.map(i => i.title).join(', ') }}</div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title mb-4">Address</h5>
                    <div v-if="item.residential_address" class="row g-3 mb-2">
                        <div class="col-sm-3"><span class="text-muted">Residence:</span></div>
                        <div class="col-sm-7">
                            <span class="">{{ item.residential_address.street_address }}</span> <br />
                            <span class="" v-if="item.residential_address.lga">{{ item.residential_address.lga.name }}</span>,
                            <span class="" v-if="item.residential_address.state">{{ item.residential_address.state.name }}</span>
                        </div>
                    </div>
                    <div v-if="item.polling_address" class="row g-3">
                        <div class="col-sm-3"><span class="text-muted">Polling Unit:</span></div>
                        <div class="col-sm-7">
                            <span class="" v-if="item.polling_address.unit">{{ item.polling_address.unit.name }}</span> <br />
                            <span class="" v-if="item.polling_address.ward">{{ item.polling_address.ward.name }}</span>,
                            <span class="" v-if="item.polling_address.lga">{{ item.polling_address.lga.name }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="item.candidate" class="card">
                <div class="card-body">
                    <h5 class="card-title mb-4">Unique Identities</h5>
                    <div class="row g-3 mb-2">
                        <div class="col-sm-3"><span class="text-muted">NIN:</span></div>
                        <div class="col-sm-7"> {{ item.candidate.nin }}</div>
                    </div>
                    <div class="row g-3 mb-2">
                        <div class="col-sm-3"><span class="text-muted">VIN:</span></div>
                        <div class="col-sm-7"> {{ item.candidate.vin }}</div>
                    </div>
                </div>
            </div>
            <origin-information :item="item.candidate" />
        </div>
    </div>
</template>

<script>
import OriginInformation from '@/components/cards/OriginInformation.vue'

export default {
    components: {
        OriginInformation
    },
    props:{
        item:{
            type: Object,
            required: true
        }
    }
}
</script>

<style></style>